import React, { useEffect, useState } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import RegularButton from 'components/CustomButtons/Button';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { wsGetAll, wsPost } from 'services/WService';

function RemoveSellerMarkModal(props) {
  const { model, setOpen, setSellerExcludedMarks, showNotify } = props;
  const [marks, setMarks] = useState([]);
  const [selectedExcludedMark, setSelectedExcludedMark] = useState();
  const [processing, setProcessing] = useState(false);

  async function listMarks() {
    let res = await wsGetAll('logi/mark');
    if (res.success) setMarks(res.data);
  }
  async function excludedMark() {
    setProcessing(true);
    let res = await wsPost(`base/seller/${model.id}/excluded-mark`, {
      logi_mark_id: selectedExcludedMark.id,
    });
    setProcessing(false);

    if (res.success) {
      showNotify(res.message);
      setSellerExcludedMarks(res.data);
      setOpen({ open: false });
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listMarks();
  }, []);

  return (
    <ModalBase
      title={`Remover Marcas`}
      maxWidth="sm"
      fullWidth
      model={model}
      setOpen={setOpen}
      entity=""
      hideSave
      footerComponent={
        <RegularButton
          color="success"
          size="sm"
          onClick={excludedMark}
          disabled={processing || selectedExcludedMark === undefined}
        >
          Agregar
        </RegularButton>
      }
    >
      <SelectAutoComplete
        label="Marca"
        required
        options={marks}
        selectedOption={selectedExcludedMark}
        setSelectedOption={setSelectedExcludedMark}
        disabled={processing}
      />
    </ModalBase>
  );
}

export default RemoveSellerMarkModal;
